module.exports = __webpack_public_path__ + "img/DS8208x12PP_Large.3dcadae6.jpg";